import type { AlertProps } from '@mui/material';

import { Alert, Typography } from '@mui/material';

type ErrorMessageProps = {
  error?: Error;
  message?: null | string;
  title: string;
} & Omit<AlertProps, 'severity'>;

export const ErrorMessage = ({
  error,
  message,
  title,
  ...props
}: ErrorMessageProps) => {
  return (
    <Alert severity="error" {...props}>
      <Typography variant="h6">{title}</Typography>
      {message && <Typography variant="body1">{message}</Typography>}
      {error && (
        <Typography
          color="text.secondary"
          fontSize={10}
          sx={{ whiteSpace: 'pre-wrap' }}
          variant="body2"
        >
          {JSON.stringify(error, Object.getOwnPropertyNames(error))}
        </Typography>
      )}
    </Alert>
  );
};
